/**
 * @deprecated this bucket belongs to old s3 account.
 * If you encounter this, discuss which bucket to use in place.
 */
export const DEPRECATED_S3_BUCKET = process.env.NEXT_PUBLIC_S3_BUCKET ?? "";
